import { createAction } from '@reduxjs/toolkit';
import { ServiceAccountDetailsFormData } from 'src/components/pages/ServiceAccountDetails/ServiceAccountDetailsForm/ServiceAccountDetailsForm';
import { AutoAssignChange } from 'src/components/ui/AutoAssignModal/AutoAssignModal';
import {
  ApiPaginationResponse,
  ServiceAccountTableQueryParameters,
} from 'src/components/ui/Table/Table.interface';
import { ServiceAccount } from 'src/store/models/ServiceAccount';

export const SERVICE_ACCOUNT_SLICE = 'serviceAccount';

/* Get service account list */
export const getServiceAccountList = createAction<{
  params: ServiceAccountTableQueryParameters<void, ServiceAccount>;
}>(`${SERVICE_ACCOUNT_SLICE}/getServiceAccountList`);

/* Set service account list */
export const setServiceAccountList = createAction<
  ApiPaginationResponse<ServiceAccount[]>
>(`${SERVICE_ACCOUNT_SLICE}/setServiceAccountList`);

/* Get service account details */
export const getServiceAccountDetails = createAction<{ serviceId: string }>(
  `${SERVICE_ACCOUNT_SLICE}/getServiceAccountDetails`
);

/* Set service account details */
export const setServiceAccountDetails = createAction<ServiceAccount>(
  `${SERVICE_ACCOUNT_SLICE}/setServiceAccountDetails`
);

/* Change service account status */
export const changeServiceAccountStatus = createAction<{
  service: ServiceAccount;
  enabled: boolean;
}>(`${SERVICE_ACCOUNT_SLICE}/changeServiceAccountStatus`);

export const setServiceAccountStatus = createAction<{
  service: ServiceAccount;
  enabled: boolean;
}>(`${SERVICE_ACCOUNT_SLICE}/setServiceAccountStatus`);

/* Edit service account details */
export const editServiceAccountDetails =
  createAction<ServiceAccountDetailsFormData>(
    `${SERVICE_ACCOUNT_SLICE}/editServiceAccountDetails`
  );

/* Add service account */
export const addServiceAccount = createAction<ServiceAccountDetailsFormData>(
  `${SERVICE_ACCOUNT_SLICE}/addServiceAccount`
);

/* Remove service account */
export const removeServiceAccount = createAction<ServiceAccountDetailsFormData>(
  `${SERVICE_ACCOUNT_SLICE}/removeServiceAccount`
);

/* Get auto assign service account list */
export const getAutoAssignServiceAccountList = createAction<{
  params: ServiceAccountTableQueryParameters<void, ServiceAccount>;
}>(`${SERVICE_ACCOUNT_SLICE}/getAutoAssignServiceAccountList`);

/* Set auto assign service account list */
export const setAutoAssignServiceAccountList = createAction<
  ApiPaginationResponse<ServiceAccount[]>
>(`${SERVICE_ACCOUNT_SLICE}/setAutoAssignServiceAccountList`);

/* Bulk edit auto assign list */
export const bulkEditAutoAssign = createAction<AutoAssignChange>(
  `${SERVICE_ACCOUNT_SLICE}/bulkEditAutoAssign`
);
